import { styled, TextField, TextFieldProps, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useFormFactor } from '../../hooks/useWidth'

const BorderlessTextField = styled(TextField)(() => {
  const theme = useTheme()
  return {
    width: '100%',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.background.default,
    },
    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.background.default,
    },
    '.MuiOutlinedInput-root:hover fieldset': {
      borderColor: theme.palette.background.default,
    },
    '.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.background.default,
    },
  }
})

export const SearchTextInput = ({ placeholder, ...rest }: TextFieldProps) => {
  const { t } = useTranslation('searchBar')
  const { isMobile } = useFormFactor()
  const placeholderText = placeholder
    ? placeholder
    : t(isMobile ? 'placeholderMobile' : 'placeholder')

  return (
    <BorderlessTextField data-testid={'search_input'} placeholder={placeholderText} {...rest} />
  )
}
